// src/pages/delivery/DeliveryLoginPage.jsx
import React from "react";
import DeliveryLogin from "../../components/delivery/DeliveryLogin";

const DeliveryLoginPage = () => {
  return <DeliveryLogin />;
};

export default DeliveryLoginPage;
